module.exports = __webpack_public_path__ + "static/media/Circle.535744fe.svg";